interface SchemaJsonLdProps {
  data: Record<string, unknown>;
}

/**
 * 输出结构化数据（JSON-LD），仅在页面存在对应真实内容时使用。
 */
export default function SchemaJsonLd({ data }: SchemaJsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}